import React from 'react';

import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import classNames from 'classnames';

import {
  CommentaireResponseDto,
  UserDtoProfileEnum,
} from 'lib_api/lib/api/gen';

import { useUserStore } from 'hooks/UserStoreContext';

import './CommentaireActions.less';

interface CommentaireActionsProps {
  setUpdateFormulaireIsOpen: (value: boolean) => void;
  setDeleteFormulaireIsOpen: (value: boolean) => void;
  commentaire: CommentaireResponseDto;
}

export const CommentaireActions = ({
  setUpdateFormulaireIsOpen,
  setDeleteFormulaireIsOpen,
  commentaire,
}: CommentaireActionsProps): React.ReactElement => {
  const user = useUserStore();

  const isCurrentUserCommentaire = commentaire.userId === user.id;
  const isAdminFonctionnel =
    user.profile === UserDtoProfileEnum.ADMIN_FONCTIONNEL;

  return (
    <div className="commentaireActions">
      <EditOutlined
        className={classNames(
          'commentaireActionIcon',
          isCurrentUserCommentaire ? 'commentaireActionIconDisponible' : '',
        )}
        onClick={() => setUpdateFormulaireIsOpen(true)}
      />
      <DeleteOutlined
        className={classNames(
          'commentaireActionIcon',
          isAdminFonctionnel || isCurrentUserCommentaire
            ? 'commentaireActionIconDisponible'
            : '',
        )}
        onClick={() => setDeleteFormulaireIsOpen(true)}
      />
    </div>
  );
};
